/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Exercise_Secondary_EquipmentInputs */

const en_us2_exercise_secondary_equipment = /** @type {(inputs: Exercise_Secondary_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Also: ${i?.name}`)
};

const pt_br2_exercise_secondary_equipment = /** @type {(inputs: Exercise_Secondary_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Também: ${i?.name}`)
};

const es_419_exercise_secondary_equipment = /** @type {(inputs: Exercise_Secondary_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`También: ${i?.name}`)
};

const pt_pt2_exercise_secondary_equipment = /** @type {(inputs: Exercise_Secondary_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Também: ${i?.name}`)
};

const fr_fr2_exercise_secondary_equipment = /** @type {(inputs: Exercise_Secondary_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aussi : ${i?.name}`)
};

const de_de2_exercise_secondary_equipment = /** @type {(inputs: Exercise_Secondary_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Außerdem: ${i?.name}`)
};

const it_it2_exercise_secondary_equipment = /** @type {(inputs: Exercise_Secondary_EquipmentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anche: ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Also: {name}" |
*
* @param {Exercise_Secondary_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_secondary_equipment = /** @type {((inputs: Exercise_Secondary_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Secondary_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_secondary_equipment(inputs)
	if (locale === "es-419") return es_419_exercise_secondary_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_secondary_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_secondary_equipment(inputs)
	if (locale === "de-DE") return de_de2_exercise_secondary_equipment(inputs)
	if (locale === "it-IT") return it_it2_exercise_secondary_equipment(inputs)
	return en_us2_exercise_secondary_equipment(inputs)
});
export { exercise_secondary_equipment as "exercise.secondary_equipment" }